module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACQSURBVHgBtdIxDoMgFMbx94Du7k2alybde5Ueo5PxBHoD3Ux08GqMHsEE4YnOqATjNwK/5D8AcMf617tqiSh0J46gEq55WKxDGOFkA1FmLQ5GcvHXWkfDPRwFQxi75+eLyFkMRuvfSS6Ncj+1HkiYOQaCAnbsI6eUVONTR5+agrbsFHQK99C6w5/jZpGH0KUtwEVgUEQmsLUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Frame.png
// module id = Lvd7
// module chunks = 1